module.exports = __webpack_public_path__ + "img/WQ.c6b2e169.svg";